<kendo-dialog title="Assign Student(s) to Agencies" *ngIf="showAssignStudentAgency" (close)="onHideHandler()"
  (open)="onShowHandler()" maxHeight="90vh" width="75vw" [minHeight]="300"
  [animation]="{ duration: 300, type: 'fade', direction: 'down' }">
  <p>Please select one or more agencies to assign the selected students to.</p>
  <div class="k-d-flex">
    <div>
      <kendo-listview [kendoListViewBinding]="gridData" containerClass="k-d-flex k-flex-col k-flex-nowrap">
        <ng-template kendoListViewHeaderTemplate>
          <div class="header">
            Selected {{ gridData.length > 0 ? gridData.length : 0 }} agencies (3
            max)
            <span style="cursor: pointer; color: #3271e7; margin-left: 241px" role="button" tabindex="0"
              (click)="clearAll()" (keydown.enter)="clearAll()" (keydown.space)="clearAll()">Clear All</span>
          </div>
          @if(gridData.length === 0) {
            <p class="secondary-color">You currently have 0 agencies selected. Please select an agency in the “List of Evaluation Sites.”</p>
          }
        </ng-template>
        <ng-template kendoListViewItemTemplate let-dataItem="dataItem" let-index="index">
          <div>
            <div>
              <!-- TODO: Avoid inline styles. Move padding to a CSS class or stylesheet. -->
              <div style="padding: 14px">
                <div>
                  <div class="waitlist-label">
                    <div>
                      <p class="count-style">
                        {{ dataItem?.waitListCount }} on waitlist
                      </p>
                    </div>
                    <div>
                      <button kendoButton [svgIcon]="trashIcon" (click)="removeData(dataItem)" title="Delete"
                        themeColor="error" fillMode="outline" size="medium"></button>
                    </div>
                  </div>
                  <h4>{{ dataItem?.siteLocation }}</h4>
                  <p class="more-details" role="button" tabindex="0" (click)="toggleMoreDetails(dataItem, index)"
                    (keydown.enter)="toggleMoreDetails(dataItem, index)"
                    (keydown.space)="toggleMoreDetails(dataItem, index)">
                    More Details
                  </p>
                </div>
                <app-more-details *ngIf="expanded && itemIndexNumber === index"
                  [moreDetails]="moreDetailsItem"></app-more-details>
              </div>
            </div>
          </div>
        </ng-template>
      </kendo-listview>
    </div>
    <div class="loading-container">
      <kendo-loader *ngIf="loadSpinner" type="converging-spinner" size="large"></kendo-loader>
    </div>
    <div style="margin-left: 49px">
      <!-- TODO: Avoid inline styles. Move padding to a CSS class or stylesheet. -->
      <kendo-listview [data]="gridDetails" containerClass="k-d-flex k-flex-col k-flex-nowrap">
        <ng-template kendoListViewHeaderTemplate>
          <div class="k-d-flex k-justify-content-between k-align-items-center">
            <h3>List of Evaluation Sites</h3>
            <button kendoButton size="medium" rounded="large" fillMode="solid" (click)="openFilterDialog()"
              [svgIcon]="filterIcon" class="btn-style">
              Filter
            </button>
          </div>
          <div class="separator"></div>
          <kendo-textbox [style.width.px]="298" class="filter-textbox" placeholder="Search Site Name or Evaluation ID"
            (valueChange)="onFilter($event)">
          </kendo-textbox>
        </ng-template>

        <ng-template kendoListViewItemTemplate let-dataItem="dataItem" let-isFirst="isFirst">
          <div class="evaluation-site">
            <p class="count-style">
              {{ dataItem?.waitListCount ?? 0 }} on waitlist
            </p>
            <h4>[{{ dataItem?.locationCode }}] {{ dataItem?.siteLocation }}</h4>
            <p>
              {{ dataItem?.addressLine1 }}, {{ dataItem?.addressLine2
              }}<span *ngIf="dataItem?.addressLine2">,</span>
              {{ dataItem?.stateCode }}, {{ dataItem?.city }}, {{ dataItem?.zip}},
              <span>District</span> {{ dataItem?.geographicalDistrictCode }}
            </p>

            <div>
              <p>
                <fa-icon icon="location-crosshairs" class="fa-md k-pr-2 icon-color k-align-self-center"></fa-icon>
                {{ dataItem?.boroNames }}
              </p>
              <p>
                <fa-icon icon="language" class="fa-md k-pr-2 icon-color k-align-self-center"></fa-icon>
                {{ dataItem?.languageList }}
              </p>
            </div>

            <div class="button-group k-mt-2">
              <button class="btn-style k-mr-2" kendoButton (click)="selectedData(dataItem)">
                Select
              </button>
              <button class="btn-style k-mr-2" kendoButton (click)="openContactDialog(dataItem)">
                Contact
              </button>
              <button class="btn-style k-mr-2" kendoButton (click)="openWebsite(dataItem)">
                View Website
              </button>
            </div>
          </div>
          <div class="separator"></div>
        </ng-template>

        <div class="separator"></div>

        <ng-template kendoListViewFooterTemplate>
          <div class="footer">Total Sites: {{ gridDetails.length }}</div>
        </ng-template>
      </kendo-listview>
    </div>
  </div>

  <kendo-dialog-actions>
    <button (click)="assignSelectedData()" [disabled]="gridData?.length === 0" kendoButton themeColor="primary">
      Assign to Selected Agencies
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<!-- Contact Dialog -->
<kendo-dialog *ngIf="showContactDialog" title="Contact Information" (close)="closeContactDialog()" width="25vw">
  <div>
    <h4>{{ contactData?.siteLocation }}</h4>
    <p>
      <strong>{{ contactData?.contactPersonLastName | titlecase }}
        {{ contactData?.contactPersonFirstName | titlecase }}</strong>
    </p>
    <p>
      <fa-icon icon="phone"></fa-icon>
      <span class="k-ml-2">
        <ng-container *ngIf="contactData?.contactPhoneNumber">
          {{ contactData?.contactPhoneNumber }} (tele)
        </ng-container>
        <ng-container *ngIf="
            contactData?.contactPhoneNumber && contactData?.contactFaxNumber
          ">
          ,
        </ng-container>
        <ng-container *ngIf="contactData?.contactFaxNumber">
          {{ contactData?.contactFaxNumber }} (fax)
        </ng-container>
      </span>
    </p>
    <p>
      <fa-icon icon="envelope"></fa-icon>
      <span class="k-ml-2">{{ contactData?.contactEmail }}</span>
    </p>
  </div>

  <kendo-dialog-actions>
    <button kendoButton (click)="closeContactDialog()">Close</button>
  </kendo-dialog-actions>
</kendo-dialog>

<!-- Filters Dialog -->
<kendo-dialog (close)="showFilter = false" *ngIf="showFilter" width="30vw" [minHeight]="300">
  <kendo-dialog-titlebar>
    <h4 class="!k-m-0 font-20">Filters</h4>
  </kendo-dialog-titlebar>
  <div class="content" [formGroup]="form">
    <kendo-floatinglabel text="Agency Name" class="k-w-full">
      <kendo-textbox size="medium" rounded="large" formControlName="agencyName"></kendo-textbox>
    </kendo-floatinglabel>
    <kendo-floatinglabel text="District" class="k-w-full">
      <kendo-multiselect [data]="referenceData?.district" textField="description" [valuePrimitive]="true"
        valueField="value" formControlName="district"></kendo-multiselect>
    </kendo-floatinglabel>
    <kendo-floatinglabel text="Location Code" class="k-w-full">
      <kendo-textbox size="medium" rounded="large" formControlName="locationCode"></kendo-textbox>
    </kendo-floatinglabel>
    <kendo-floatinglabel text="Borough" class="k-w-full">
      <kendo-multiselect [data]="referenceData?.borough" textField="description" [valuePrimitive]="true"
        valueField="value" formControlName="borough"></kendo-multiselect>
    </kendo-floatinglabel>
    <kendo-floatinglabel text="Language(s) Supported" class="k-w-full">
      <kendo-multiselect [data]="referenceData?.language" textField="description" [valuePrimitive]="true"
        valueField="id" formControlName="language"></kendo-multiselect>
    </kendo-floatinglabel>

    <kendo-floatinglabel text="Number on Waitlist" class="k-w-full k-d-block k-mt-2">
      <kendo-slider class="!k-w-full" [title]="title" [min]="minRange" [max]="200" [largeStep]="50"
        formControlName="range" [showButtons]="false"></kendo-slider>
    </kendo-floatinglabel>
  </div>
  <kendo-dialog-actions>
    <button kendoButton themeColor="primary" size="medium" rounded="large" fillMode="solid" class="!k-w-full"
      (click)="applyFilters()">
      Apply Filters
    </button>
  </kendo-dialog-actions>
</kendo-dialog>